import { d as deprecated } from './6cf04c83.mjs';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const delegationStore = [];
function isEventable(element) {
  return typeof element === "object" && typeof element.addEventListener === "function";
}
function isQueryable(element) {
  return !!element && typeof element === "object" && typeof element.querySelectorAll === "function";
}
function addEvent(params) {
  params.target.addEventListener(params.eventType, params.listener, params.options);
}
function getMutationCallback(config) {
  return (mutations) => {
    mutations.forEach(
      (m) => Array.from(m.addedNodes).filter((e) => e instanceof Element && typeof e.matches === "function").forEach(
        (e) => config.delegations.forEach((d) => {
          const els = Array.from(e.querySelectorAll(d.targetSelector));
          if (isEventable(e) && e.matches(d.targetSelector)) {
            els.push(e);
          }
          els.forEach((target) => addEvent(__spreadProps(__spreadValues({}, d), { target })));
        })
      )
    );
  };
}
function getContainerElement(containerOrSelector) {
  return containerOrSelector === "document" ? document : isQueryable(containerOrSelector) ? containerOrSelector : typeof containerOrSelector === "string" ? document.querySelector(containerOrSelector) : null;
}
function queryDelegationTargets(container, targetSelector) {
  return Array.from(container.querySelectorAll(targetSelector)).filter(isEventable);
}
function findDelegationConfig(container) {
  return delegationStore.find((c) => c.container === container);
}
function addDelegationConfig(container) {
  const config = { container, delegations: [], observer: void 0 };
  config.observer = new MutationObserver(getMutationCallback(config));
  config.observer.observe(container, { subtree: true, childList: true });
  delegationStore.push(config);
  return config;
}
function findDelegation(config, eventType, targetSelector, listener) {
  const delegation = config.delegations.find(
    (d) => d.listener === listener && d.eventType === eventType && d.targetSelector === targetSelector
  );
  return delegation;
}

function delegate(containerOrSelector, eventType, targetSelector, listener, options = false) {
  const container = getContainerElement(containerOrSelector);
  if (!container) {
    return false;
  }
  let config = findDelegationConfig(container);
  if (!config) {
    config = addDelegationConfig(container);
  }
  queryDelegationTargets(container, targetSelector).forEach(
    (element) => addEvent({ target: element, eventType, listener, options })
  );
  const delegation = findDelegation(config, eventType, targetSelector, listener);
  if (!delegation) {
    config.delegations.push({ listener, options, eventType, targetSelector });
  }
  return true;
}
function undelegate(containerOrSelector, eventType, targetSelector, listener, options) {
  const element = getContainerElement(containerOrSelector);
  if (!element) {
    return false;
  }
  const config = findDelegationConfig(element);
  if (!config) {
    return false;
  }
  const delegation = findDelegation(config, eventType, targetSelector, listener);
  if (!delegation) {
    return false;
  }
  config.delegations.splice(config.delegations.indexOf(delegation), 1);
  queryDelegationTargets(element, targetSelector).map(
    (target) => target.removeEventListener(eventType, listener, options)
  );
  return true;
}
function stop(event) {
  event.stopPropagation();
  event.preventDefault();
}
function whichTransitionEndEvent() {
  const el = document.createElement("fakeelement");
  const res = Object.entries({
    WebkitTransition: "webkitTransitionEnd",
    transition: "transitionend",
    OTransition: "oTransitionEnd",
    MozTransition: "transitionend",
    DEFAULT: ""
  }).filter(([k]) => el.style[k] !== void 0 || k === "DEFAULT").map(([, v]) => v)[0];
  return res;
}
function add(obj, type, fn, useCapture = false) {
  deprecated("o_util.event.add", "use native addEventListener instead");
  obj.addEventListener(type, fn, useCapture);
}
function remove(obj, type, fn) {
  deprecated("o_util.event.remove", "use native removeEventListener instead");
  obj.removeEventListener(type, fn, false);
}
function stopPropagation(event) {
  deprecated("o_util.event.stopPropagation", "use native event.stopPropagation instead");
  event.stopPropagation();
}
function getTarget(event) {
  deprecated("o_util.event.getTarget", "use native event.target instead");
  return event.target;
}
function preventDefault(event) {
  deprecated("o_util.event.preventDefault", "use native event.preventDefault instead");
  event.preventDefault();
}
function trigger(element, type) {
  deprecated("o_util.event.trigger", "use native CustomElements instead");
  const event = document.createEvent("HTMLEvents");
  event.initEvent(type, true, true);
  element.dispatchEvent(event);
}

var index = /*         */Object.freeze({
  __proto__: null,
  add: add,
  delegate: delegate,
  getTarget: getTarget,
  preventDefault: preventDefault,
  remove: remove,
  stop: stop,
  stopPropagation: stopPropagation,
  trigger: trigger,
  undelegate: undelegate,
  whichTransitionEndEvent: whichTransitionEndEvent
});

export { add as a, stopPropagation as b, delegate as d, getTarget as g, index as i, preventDefault as p, remove as r, stop as s, trigger as t, undelegate as u, whichTransitionEndEvent as w };
/*                                 */
